import React from 'react';

// @mui
import { Alert, Box, Button, Divider, Stack, Typography } from '@mui/material';
import i18n from '../../i18n';
import { AppDataContext } from '../../context/Context';
import QRCode from 'react-qr-code';
import CodeAuthField from '../../components/code-auth-input/CodeAuthField';
import { formatError } from '../../utils/formatError';

export default class Dialog2FAField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            secretCode: null,
            qr: null,
            error: { message: '', severity: 'error' },
            disable2FA: false
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.value !== state.value) {
            return {
                value: props.value
            };
        }
        return null;
    }

    async refresh() {
        const data = await this.context.getState().server.users.metaInfo();
        this.context.update({
            userInfo: {
                ...data.currentUser
            }
        });
    }

    async handleEnabledButtonClick() {
        //enable 2fa
        const data = await this.context.getState().server.users.enable2FA();

        const qr = decodeURIComponent(data?.qr);

        this.setState({ secretCode: data.secret, qr });
    }
    handleActivate = async (code) => {
        //activate 2fa

        const result = await this.context
            .getState()
            .server.users.activate2FA(code);
        if (result.error === 'OK') {
            this.setState({
                secretCode: null,
                qr: null,
                error: {
                    message: i18n.t('auth.2FAEnabled'),
                    severity: 'success'
                }
            });
            this.refresh();
        } else {
            this.setState({
                error: {
                    message: formatError(result),
                    severity: 'error'
                }
            });
        }
    };
    handleDisabled = async (code) => {
        //disable 2fa
        const result = await this.context
            .getState()
            .server.users.disable2FA(code);
        if (result.error === 'OK') {
            this.setState({
                disable2FA: false,
                error: {
                    message: i18n.t('auth.2FADisabled'),
                    severity: 'success'
                }
            });
            this.refresh();
        } else {
            this.setState({
                error: {
                    message: formatError(result),
                    severity: 'error'
                }
            });
        }
    };
    renderButton() {
        return (
            <Stack spacing={3} mt={2}>
                {this.state.value ? (
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={() => this.setState({ disable2FA: true })}
                    >
                        {i18n.t('auth.disable2FA')}
                    </Button>
                ) : (
                    <Button
                        variant="outlined"
                        onClick={() => this.handleEnabledButtonClick()}
                    >
                        {i18n.t('auth.enable2FA')}
                    </Button>
                )}
            </Stack>
        );
    }

    render() {
        // field, value, cache, onChange
        return (
            <>
                {this.state.secretCode && (
                    <>
                        <Stack spacing={3} mt={2} pb={2}>
                            <Typography variant="h6">{i18n.t('auth.scanQRCode')}</Typography>
                            <Box display="flex" justifyContent="center">
                                <QRCode size={177} value={this.state.qr} />
                            </Box>
                            <Typography variant="h6">
                                {i18n.t('auth.orSecretKey')}
                            </Typography>
                            <Box display="flex" justifyContent="center">
                                <Typography variant="h6">{this.state.secretCode}</Typography>
                            </Box>
                        </Stack>
                        <Divider />
                        <Stack spacing={3} mt={2} mb={2}>
                            <Typography variant="h6">{i18n.t('auth.enterCode')}</Typography>
                            <CodeAuthField callback={this.handleActivate} />
                        </Stack>
                    </>
                )}
                {this.state.disable2FA && (
                    <Stack spacing={3} mt={2} mb={2}>
                        <Typography variant="h6">{i18n.t('auth.enterCode')}</Typography>
                        <CodeAuthField callback={this.handleDisabled} />
                    </Stack>
                )}
                {this.state.error.message && (
                    <Alert severity={this.state.error.severity}>
                        {this.state.error.message}
                    </Alert>
                )}
                {!this.state.secretCode && this.renderButton()}
            </>
        );
    }
}
Dialog2FAField.contextType = AppDataContext;
